//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  OauthTikTokAdsResponse,
  TikTokAdsConnectionStatus,
} from '@apis/tiktok-settings-ads//tiktokSettingsAdsApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const PASSTHROUGH_DEFAULT = '/api/v1/pass-through';
const TIKTOK_AD_ACCOUNTS_BASE_URL = `${PASSTHROUGH_DEFAULT}/api/soco/organization/tiktok-ad-accounts`;

// TODO: PD-250821: Remove this function once all endpoints are made available in the gateway
const passthroughFetch = (
  endpoint: string,
  init?: RequestInit,
  useFetchHeader?: boolean,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'affable_gateway',
    `${TIKTOK_AD_ACCOUNTS_BASE_URL}${endpoint}`,
    init,
    useFetchHeader,
  );
};

/**
 * Gets the TikTok Ads Manager Account connection status
 *
 * GET /api/soco/organization/tiktok-ad-accounts
 */
export const getConnectionStatus = async (
  init?: RequestInit,
): Promise<TikTokAdsConnectionStatus> => {
  // TODO PD-257470: Replace once endpoint is available in gateway
  const res = await passthroughFetch(``, { ...init, method: 'GET' });
  return res.json<TikTokAdsConnectionStatus>();
};

/**
 * Gets the TikTok Ads Manager Account OAuth URL
 *
 * GET /api/soco/organization/tiktok-ad-accounts/oauth/url
 */
export const getOAuthUrl = async (
  init?: RequestInit,
): Promise<{ url: string }> => {
  // TODO PD-257470: Replace once endpoint is available in gateway
  const res = await passthroughFetch(`/oauth/url`, { ...init, method: 'GET' });
  return res.json<{ url: string }>();
};

/**
 * Connect the client's TikTok Ads Manager Account using the provided authCode
 *
 * POST /api/soco/organization/tiktok-ad-accounts/oauth
 */
export const connect = async (
  req: { authCode: string; state: string },
  init?: RequestInit,
): Promise<TikTokAdsConnectionStatus | undefined> => {
  // TODO PD-257470: Replace once endpoint is available in gateway
  const res = await passthroughFetch(`/oauth`, {
    ...init,
    method: 'POST',
    body: JSON.stringify(req),
  });

  const json = await res.json<OauthTikTokAdsResponse>();
  return json.data;
};

/**
 * Revoke the client's TikTok Ads Manager Account token
 *
 * DELETE /api/soco/organization/tiktok-ad-accounts/oauth
 */
export const revokeToken = async (init?: RequestInit): Promise<void> => {
  // TODO PD-257470: Replace once endpoint is available in gateway
  await passthroughFetch(`/oauth`, {
    ...init,
    method: 'DELETE',
  });
};
